import { Box, Typography } from "@mui/material";
import { AUTH_BG, AUTH_TEXT_PRIMARY, AUTH_TEXT_SECONDARY } from "../theme/appTheme";
import LanguageSwitcher from "./LanguageSwitcher";

// Shared shell for every auth screen that has nothing to show but a message —
// link expired, code display, already-confirmed. Logo top-center, everything
// else centered underneath. No split panel, no image, just this on a blank
// screen.
function AuthBlankScreen({ title, subtitle, children, actions }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: AUTH_BG,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: 3,
        py: { xs: 4, md: 6 },
      }}
    >
      <LanguageSwitcher />
      <img
        src="/Sibolab_Logo_darkblue_rgb.png"
        alt="Sibolab"
        style={{ height: "28px", width: "auto", objectFit: "contain", display: "block", marginBottom: "64px" }}
      />

      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center", width: "100%" }}>
        <Typography
          sx={{
            fontFamily: "Georgia, serif",
            fontWeight: 400,
            fontSize: { xs: "1.75rem", md: "2.25rem" },
            color: AUTH_TEXT_PRIMARY,
            mb: 1.5,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ color: AUTH_TEXT_SECONDARY, fontSize: "0.9375rem", maxWidth: 420, mb: 4 }}>
            {subtitle}
          </Typography>
        )}

        {children}

        {actions && <Box sx={{ mt: 4 }}>{actions}</Box>}
      </Box>
    </Box>
  );
}

export default AuthBlankScreen;
